<template>
    <tr>
        <td>
            <a href="#" class="text-black font-bold" @click.stop.prevent="editEvent">
                {{organization.name}}
            </a>
        </td>
        <td>
            {{organization.url}}
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'OrganizationList',
        props: {
            organization: Object
        },
        data() {
            return {
                search: ''
            }
        },
        computed: {},
        watch: {},
        methods: {
            editEvent() {
                this.$store.dispatch('setActiveOrganization', this.organization)
                this.$router.push({name: 'organization-edit', params: {id: this.organization.id }})
            }
        },
        mounted() {
        }
    }
</script>
